var map = {
	"./1.jpg": 2158,
	"./10.jpg": 2159,
	"./2.jpg": 2160,
	"./3.jpg": 2161,
	"./4.jpg": 2162,
	"./5.jpg": 2163,
	"./6.jpg": 2164,
	"./7.jpg": 2165,
	"./8.jpg": 2166,
	"./9.jpg": 2167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2157;